import { useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import React from "react";
import Top10 from "./components/Top10.js";
import Details from "./components/Details";
import AppHeader from "./components/AppHeader";
import UpdateTime from "./components/UpdateTime";
import Loading from "./components/Loading";
import InstallPWA from "./components/InstallPWA";
import "./App.css";
import "materialize-css";
import logo from "./crypto-banner.png";

function App() {
  const [top, setTop] = useState(null);

  useEffect(() => {
    getTop().then((data) => setTop(data));
    async function getTop() {
      const url = `https://api.coinlore.net/api/tickers/`;
      try {
        const res = await fetch(url);
        if (!res.ok) throw new Error(res.statusText);
        return res.json();
      } catch (err) {
        console.error(err);
      }
    }
  }, []);

  if (!top) return <Loading />;

  let date = new Date(top.info.time * 1000);
  let time = date.toLocaleString();

  let top10 = top.data.filter((item) => item.rank <= 10);

  return (
    <Router>
      <div className="app">
        <AppHeader />
        <InstallPWA />
        <img src={logo} alt="logo" className="logo container" />
        <UpdateTime time={time} />
        <Switch>
          <Route path="/:id">
            <Details />
          </Route>
          <Route Name="list">
            <h3 className="header center">Top 10 Ranked Crypto Currencies</h3>
            <Top10 top10={top10} />
          </Route>
        </Switch>
      </div>
    </Router>
  );
}

export default App;
